/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade.ts";

function getPatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeUrl(
  classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["classModuleId"],
  disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["disciplineId"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/classroomdiscipline/grade-and-frequence/class-modules/${classModuleId}/disciplines/${disciplineId}/included-in-grade` as const,
  };
  return res;
}

/**
 * @description Inverte a flag IsIncludedInGradeCalculation da Disciplina no Módulo. Se a configuração ainda não existir, ela é criada. Retorna o estado atualizado da configuração. **(Requer Authorization para autenticação)**
 * @summary Alternar 'Considerar no cálculo de nota' (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId/disciplines/:disciplineId/included-in-grade}
 */
export async function patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade(
  classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["classModuleId"],
  disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["disciplineId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500
    >,
    unknown
  >({
    method: "PATCH",
    url: getPatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeUrl(
      classModuleId,
      disciplineId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
